import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClub, IEventWeatherData, IFirebaseUser, IInvitation, ISport, IUserData } from '../../types';
import { User } from 'firebase/auth';

interface WeatherDataState {
  weatherData: { [key: string]: { weatherData: IEventWeatherData | null, state: string } };
}

const initialState: WeatherDataState = {
  weatherData: {},
};

export const weatherDataSlice = createSlice({
  name: 'weatherData',
  initialState,
  reducers: {
    updateWeatherDataById: (state, action: PayloadAction<{ placeIdAndDate: string, weatherData: IEventWeatherData | null, state: string }>) => {
      state.weatherData[action.payload.placeIdAndDate] = action.payload;
    }
  },
});

export const { updateWeatherDataById } = weatherDataSlice.actions;
export default weatherDataSlice.reducer;